<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="900px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs7>
                <v-text-field
                    label="奖励名称"
                    required
                    :rules="rules.required"
                    v-model="item.name"/>
              </v-flex>

              <v-flex xs5>
                <v-select
                    label="校内主管部门"
                    clearable
                    required
                    :rules="rules.required"
                    v-model="item.adminDeptId"
                    item-text="name"
                    item-value="dbid"
                    :items="adminDeptItems"
                />
              </v-flex>

              <v-flex xs12>
                <x-awardees
                    label="获奖人列表"
                    v-model="item.awardees"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                    label="奖励成果"
                    required
                    :rules="rules.required"
                    v-model="item.achievement"/>
              </v-flex>

              <v-flex xs4>
                <v-select
                    label="授奖组织类型"
                    clearable
                    required
                    :rules="rules.required"
                    v-model="item.founderType"
                    :items="[{text:'政府授奖', value:'G'}, {text:'社会授奖', value:'S'}]"
                    @change="
                                            (v) => {
                                                if(v === 'S') {
                                                    item.typeId = 'Db2MzVC9YJk';
                                                    item.levelId = 'Db4C67aLwAg';
                                                    item.gradeId = 'Db2MzVD9YA4';
                                                }
                                            }"
                />
              </v-flex>

              <v-flex xs8>
                <v-text-field
                    label="授奖组织"
                    required
                    :rules="rules.required"
                    v-model="item.founder"/>
              </v-flex>

              <v-flex xs4>
                <v-select
                    label="奖励类型"
                    clearable
                    :rules="rules.required"
                    v-model="item.typeId"
                    item-text="name"
                    item-value="dbid"
                    :items="typeItems"
                />
              </v-flex>
              <!--   :disabled="item.founderType !== 'G'"-->

              <v-flex xs4>
                <v-select
                    label="奖励级别"
                    clearable
                    required
                    :rules="rules.required"
                    v-model="item.levelId"
                    item-text="name"
                    item-value="dbid"
                    :items="levelItems"
                />
                <!--                                :disabled="item.founderType !== 'G'"-->
              </v-flex>

              <v-flex xs4>
                <v-select
                    label="奖励等级"
                    clearable
                    v-model="item.gradeId"
                    item-text="name"
                    item-value="dbid"
                    :items="gradeItems"
                />
              </v-flex>

              <v-flex xs4>
                <v-text-field
                    label="证书编号"
                    required
                    :rules="rules.required"
                    v-model="item.certificateNo"
                />
              </v-flex>

              <v-flex xs4>
                <v-select
                    label="单位排名"
                    required
                    :rules="rules.rank"
                    v-model="item.institutionRank"
                    :items="institutionRankItems"
                />
              </v-flex>

              <v-flex xs4>
                <v-menu
                    ref="grantDateMenuRef"
                    lazy
                    :close-on-content-click="false"
                    v-model="grantDateMenu"
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                >
                  <v-text-field
                      slot="activator"
                      label="获奖时间"
                      v-model="item.grantDate"
                      :rules="rules.grantDate"
                      hint="格式YYYY-MM-DD, 如：2018-10-01"
                      persistent-hint
                  />

                  <v-date-picker
                      v-model="grantDate"
                      locale="zh-cn"
                      @change="nv => item.grantDate= nv"
                  />
                </v-menu>
              </v-flex>

              <v-flex xs6>
                <v-select
                    label="归属部门"
                    clearable
                    required
                    :rules="rules.required"
                    v-model="item.deptId"
                    item-text="name"
                    item-value="dbid"
                    :items="deptItems"
                />
              </v-flex>

              <v-flex xs6>
                <v-autocomplete
                    label="所属学科"
                    clearable
                    required
                    :rules="rules.required"
                    v-model="item.subjectId"
                    item-text="name"
                    item-value="dbid"
                    :items="subjectItems"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                    label="备注"
                    v-model="item.note"
                />
              </v-flex>

              <v-flex xs12>
                <x-uploader
                    label="附件列表"
                    :action="fileUri"
                    v-model="item.attachments"
                    :size="Number(50)"
                    description="单个附件大小不超过 50M."
                />
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import mixin from '@/mixin'
import XAwardees from './widgets/Awardees'

import XUploader from '@/components/global/Uploader'

const baseURI = '/api/awar/award';
const typeURI = '/api/awar/type';
const levelURI = '/api/awar/level';
const gradeURI = '/api/awar/grade';
const subjectURI = '/api/code/subject';
const deptURI = '/api/syst/department';

export default {
  mixins: [mixin.edit(baseURI)],
  components: {XAwardees, XUploader},

  data() {
    return {
      formValid: false,

      fileUri: '/api/awar/file',

      item: {},
      freshItem: {
        "name": null,
        "awardees": [],
        "achievement": null,
        "levelId": null,
        "gradeId": null,
        "typeId": null,
        "departmentId": null,
        "grantDate": null,
        "institutionRank": null,
        "subjectId": null,
        "certificateNo": null,
        "note": null,
        "founderType": null,
        "founder": null
      },

      grantDateMenu: false,
      grantDate: null,

      institutionRankItems: window.xutil.range(1, 16).map(
          y => {
            return {
              "value": y, "text": '第' + y + '单位'
            }
          }
      ).concat([{
        "value": 0, "text": '未署名'
      }]),

      typeItems: [],
      levelItems: [],
      gradeItems: [],
      subjectItems: [],
      deptItems: [],
      adminDeptItems: [],

      /**
       * 验证规则
       */
      rules: {
        required: [
          v => !!v || '必填项。'
        ],
        rank: [
          v => (v === 0 || !!v) || '必填项。'
        ],
        grantDate: [
          v => !!v || "必填项。",
          v => window.xutil.regexpDate().test(v) || '日期格式错误'
        ],
        year: [v => !!v || '必填项。'],
        note: [v => (v && v.length <= 255) || '长度必须小于255个字符。']
      }
    }
  },

  created() {
    this.axios.all([
      this.axios.get(deptURI, {params: {limit: 65535, disabled: 'F'}}),
      this.axios.get(subjectURI, {
        params: {
          limit: 65535,
          disabled: 'F',
          codeIsNotNull: true,
          sort: 'order.asc'
        }
      }),
      this.axios.get(typeURI, {params: {limit: 65535, disabled: 'F', sort: 'order.asc'}}),
      this.axios.get(levelURI, {params: {limit: 65535, disabled: 'F', sort: 'order.asc'}}),
      this.axios.get(gradeURI, {params: {limit: 65535, disabled: 'F', sort: 'order.asc'}}),
    ]).then(
        this.axios.spread(
            (rspDept, rspSubj, rspType, rspLevel, rspGrade) => {
              this.deptItems = rspDept.data.items;
              this.subjectItems = rspSubj.data.items;
              this.typeItems = rspType.data.items;
              this.levelItems = rspLevel.data.items;
              this.gradeItems = rspGrade.data.items;

              this.adminDeptItems = rspDept.data.items.filter(v => v.isAdmin);
            }
        )
    )
  },

  watch: {},

  methods: {
    // mixin 加载数据后调用
    // afterGetData(data) {
    // },
  }
}
</script>
